import { Tag } from 'antd';
import { companyColors } from 'apps/investment/constants';
import { fundEContractStatusColors } from 'apps/investment/constants/fund-econtracts';
import BooleanIcons from 'common/ui/boolean-icons';
import InfoCard from 'common/ui/info-card';
import { commonDictionary } from 'config/dictionary';
import {} from 'lodash';
import { Link } from 'react-router-dom';
import { formatDateTime } from 'utils/formatDate';

const ItemDetail = ({ item }) => {
  const { trading_account_manager, link } = item || {};

  return (
    <div>
      <div className="space-y-4">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <InfoCard
            label="Nhà phân phối"
            value={
              <Tag color={companyColors[trading_account_manager]}>
                {trading_account_manager}
              </Tag>
            }
          />
          <InfoCard
            label={commonDictionary.status}
            value={
              <Tag color={fundEContractStatusColors[item.status]}>
                {item.status_label
                  ? `${item.status_label} (${item.status})`
                  : item.status}
              </Tag>
            }
          />
          <InfoCard label="Contract ID" value={item.contract_id} />
          <InfoCard label="Contract Number" value={item.contract_number} />
          <InfoCard
            label="Fund Manager"
            value={
              <Tag color={companyColors[item.fund_manager]}>
                {item.fund_manager}
              </Tag>
            }
          />
          <InfoCard
            label="Fund Account ID"
            value={
              item.fund_account_id ? (
                <Link to={`/investment/fund-accounts/${item.fund_account_id}`}>
                  {item.fund_account_id}
                </Link>
              ) : (
                '-'
              )
            }
          />

          <InfoCard
            className="col-span-2 text-wrap break-words"
            label="Contract Link"
            value={link}
          />
          <InfoCard
            className="h-fit"
            label="Được phép ký hđ"
            value={<BooleanIcons value={item.contract_is_allow_signing} />}
          />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <InfoCard
            label="User"
            value={
              <Link to={`/investment/users/${item.user_id}`}>
                {item.user_id}
              </Link>
            }
          />
        </div>
      </div>

      <div className="bg-gray-50 -mx-6 -mb-6 p-6 rounded-b-lg mt-4 space-y-4">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <InfoCard
            label="Created At"
            value={formatDateTime(item.created_at)}
          />
          <InfoCard
            label="Updated At"
            value={formatDateTime(item.updated_at)}
          />
        </div>
      </div>
    </div>
  );
};

export default ItemDetail;
